import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=2f5b6ccc&scoped=true&"
import script from "./LocationList.vue?vue&type=script&lang=ts&"
export * from "./LocationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b6ccc",
  null
  
)

export default component.exports